import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';

import styles from './therapy-component.styles.scss';


export class TherapyComponent extends React.Component {
  static propTypes = {
    therapy: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    const { title, description, tags } = this.props.therapy;
    const className = classnames(styles.Therapy, this.props.className);

    return (
      <div className={className}>
        <h2 className={styles.Title}>{ title }</h2>
        <div dangerouslySetInnerHTML={{ __html: description }} />
        <div>Kategorien: { tags.join(', ') }</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/therapy/therapy.component.jsx